<div class="ui-dialog-backdrop" tabindex="-1" (click)="dismissDialog()" (keydown.escape)="dismissDialog()">
    <div class="ui-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()" tabindex="-1"
        [attr.aria-labelledby]="titleId" #dialogContainer>
        @if(isCloseable) {
        <button type="button" class="close-btn" aria-label="Chiudi finestra di dialogo" (click)="dismissDialog()" tabindex="0">
            <mat-icon fontIcon="close"></mat-icon>
        </button>
        }
        <div class="ui-dialog-title {{ centerTitle ? 'center-title' : '' }}" [id]="titleId">
            <!-- role="heading" invece di <h2>: il contenuto proiettato dai chiamanti è
                 spesso un <div>, che dentro un heading sarebbe HTML non valido -->
            <div class="ui-dialog-title-text" role="heading" aria-level="2">
                <ng-content select="[dialog-title]"></ng-content>
            </div>
        </div>
        <div class="ui-dialog-content">
            <ng-content></ng-content>
        </div>
        <div class="ui-dialog-actions">
            <ng-content select="[dialog-actions]"></ng-content>
        </div>
    </div>
</div>
